module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    staticClass: "zk-select",
    class: {
      'is-multiple': _vm.multiple, 'is-small': _vm.size === 'small'
    }
  }, [(_vm.multiple) ? _c('div', {
    ref: "tags",
    staticClass: "zk-select__tags",
    style: ({
      'max-width': _vm.inputWidth - 32 + 'px'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleMenu($event)
      }
    }
  }, [_c('transition-group', {
    on: {
      "after-leave": _vm.resetInputHeight
    }
  }, _vm._l((_vm.selected), function(item) {
    return _c('zk-tag', {
      key: item,
      attrs: {
        "closable": "",
        "hit": item.hitState,
        "type": "primary",
        "close-transition": ""
      },
      on: {
        "close": function($event) {
          _vm.deleteTag($event, item)
        }
      }
    }, [_vm._v(_vm._s(item.currentLabel))])
  })), _vm._v(" "), (_vm.filterable) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "input",
    staticClass: "zk-select__input",
    style: ({
      width: _vm.inputLength + 'px',
      'max-width': _vm.inputWidth - 42 + 'px'
    }),
    attrs: {
      "type": "text",
      "debounce": _vm.remote ? 300 : 0
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.visible = true
      },
      "keyup": _vm.managePlaceholder,
      "keydown": [_vm.resetInputState, function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.navigateOptions('next')
      }, function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.navigateOptions('prev')
      }, function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.selectOption($event)
      }, function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.visible = false
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.deletePrevTag($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('zk-input', {
    ref: "reference",
    attrs: {
      "type": "text",
      "placeholder": _vm.currentPlaceholder,
      "name": _vm.name,
      "disabled": _vm.disabled,
      "readonly": !_vm.filterable || _vm.multiple,
      "icon": _vm.iconClass
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenu($event)
      },
      "keyup": function($event) {
        _vm.debouncedOnInputChange($event)
      },
      "keydown": [function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.navigateOptions('next')
      }, function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.navigateOptions('prev')
      }, function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.selectOption($event)
      }, function($event) {
        $event.preventDefault();
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.visible = false
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.visible = false
      }],
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    },
    model: {
      value: (_vm.selectedLabel),
      callback: function($$v) {
        _vm.selectedLabel = $$v
      },
      expression: "selectedLabel"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "md-fade-bottom"
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c('zk-select-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible && _vm.emptyText !== false),
      expression: "visible && emptyText !== false"
    }],
    ref: "popper"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.options.length > 0 && _vm.filteredOptionsCount > 0 && !_vm.loading),
      expression: "options.length > 0 && filteredOptionsCount > 0 && !loading"
    }],
    staticClass: "zk-select-dropdown__list"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.emptyText) ? _c('p', {
    staticClass: "zk-select-dropdown__empty"
  }, [_vm._v(_vm._s(_vm.emptyText))]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-5f702682"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/select/src/select.vue
// module id = 258
// module chunks = 0